export const THEME = {
  primaryBg: "bg-slate-950",
  surface: "bg-white",
  text: "text-slate-800",
  mutedText: "text-slate-500",
  accent: {
    text: "text-sky-600",
    bg: "bg-sky-600",
    hover: "hover:bg-sky-700",
    ring: "focus:ring-sky-600/30",
  },
};

export const profile = {
  name: "Rahul Uchit",
  headline: "Clinical Data Management Leader — SDTM Excellence & DCT Strategy",
  subheadline:
    "14 years delivering 100% error-free, submission-ready SDTM & Pinnacle 21 datasets across 20+ trials.",
  photo:
    "https://i.postimg.cc/Hk5CYw3v/Rahul-uchit-portfolio-photo.jpg",
  bio:
    "Rahul Uchit is a highly accomplished Clinical Data Management Professional with 14 years of experience delivering regulatory-ready, submission-quality datasets. Specializing in decentralized trials and digitalization strategies, he is a Subject Matter Expert (SME) for local lab data and standardization. Rahul ensures 100% error-free SDTM and Pinnacle 21 validated datasets, achieved across 20+ clinical trials spanning Vaccines, Oncology, Infectious Disease, and Ophthalmology (Phases I–III and RWD). He drives data cleaning strategy through focused review meetings, enabling inclusive, study-oriented decisions from trial start to finish.",
};

export const metrics = [
  { label: "Clinical trials", value: "20+" },
  { label: "Error-free SDTM & P21", value: "100%" },
  { label: "Phases", value: "I–III & RWD" },
  { label: "Therapeutic Areas", value: "Vaccines • Oncology • Ophthalmology • ID" },
];

export const focusBullets = [
  "SDTM and Pinnacle 21 validation leadership",
  "Decentralized trials & digitalization strategies",
  "Local lab data standardization (SME)",
  "Study-oriented data cleaning and focused review leadership",
];

export const skills = [
  {
    title: "Data Quality & Compliance — SDTM & P21 Validation",
    desc: "Consistently achieving 100% error-free submission-ready datasets across 20+ trials.",
  },
  {
    title: "Trial Methodology — Decentralized Trials (DCTs) & Digitalization",
    desc: "Modern trial design with digital tools for efficiency.",
  },
  {
    title: "Data Standardization — Local Lab Data Management (SME)",
    desc: "Standardization, processing, and management of local lab data.",
  },
  {
    title: "Data Review & Strategy — Functional Reviewer & Cleaning Strategy",
    desc: "Leading focused review meetings to define study-oriented endpoints.",
  },
  {
    title: "Therapeutic & Phase Experience — Diverse TAs",
    desc: "Vaccines, Infectious Disease, Oncology, Ophthalmology; Phases I–III & RWD.",
  },
  {
    title: "Full Lifecycle Management — End-to-End CDM",
    desc: "From trial start to final submission.",
  },
];

export const services = [
  {
    title: "Consulting: SDTM Deliverables & Compliance",
    outcome: "Submission-ready, P21-validated datasets.",
    tag: "SDTM",
  },
  {
    title: "Training: SDTM Best Practices & Review Strategy",
    outcome: "Upskilled teams, faster database locks.",
    tag: "Training",
  },
  {
    title: "Consulting: Local Lab Data Standardization",
    outcome: "Harmonized lab data, reduced cycle times.",
    tag: "Local Lab",
  },
  {
    title: "Advisory: Decentralized Trials (DCT) & Digitalization",
    outcome: "Efficient, modern trial operations.",
    tag: "DCT",
  },
];

export const portfolioImages = {
  abstract1: "https://images.unsplash.com/photo-1567406485713-7a6f1abcccde",
  abstract2: "https://images.unsplash.com/photo-1636990729669-70b389c7662a",
  abstract3: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
};

export const projects = [
  {
    id: "reg-submissions",
    title: "High-Quality Regulatory Submission Portfolio",
    category: "SDTM",
    problem: "Ensure submission-quality datasets across diverse TAs and phases.",
    approach: "Standardized SDTM + rigorous Pinnacle 21 validation pipelines.",
    tools: "SDTM, Pinnacle 21",
    outcome: "100% error-free SDTM & P21 across all submissions.",
    learnings: "Repeatable validation processes drive reliability.",
    thumbnail: portfolioImages.abstract3,
  },
  {
    id: "dct-standardization",
    title: "Standardization for Decentralized Trial Efficiency",
    category: "DCT",
    problem: "Fragmented lab data and digital capture in DCTs.",
    approach: "Acted as SME for local lab data; introduced digitalization standards.",
    tools: "DCT frameworks, SDTM",
    outcome: "Reduced processing cycle times; consistent, high-quality capture.",
    learnings: "Early harmonization reduces downstream churn.",
    thumbnail: portfolioImages.abstract1,
  },
  {
    id: "focused-review",
    title: "Study-Oriented Data Cleaning & Review Leadership",
    category: "Local Lab",
    problem: "Slow decision cycles and late-stage queries.",
    approach: "Led focused review meetings with cross-functional stakeholders.",
    tools: "SDTM, P21, custom review checklists",
    outcome: "Faster DB locks; fewer late-stage queries; expedited filings.",
    learnings: "Aligned definitions enable decisive progress.",
    thumbnail: portfolioImages.abstract2,
  },
];

export const experience = [
  {
    role: "Project Data Manager",
    org: "Syneos Health GmbH (Germany)",
    dates: "19-MAY-2019 – Present",
  },
  {
    role: "Business Process Lead",
    org: "TCS (India)",
    dates: "01-SEP-2016 – 10-MAY-2019",
  },
  {
    role: "Clinical Data Manager",
    org: "QuintilesIMS (IQVIA)",
    dates: "28-FEB-2015 – 16-AUG-2016",
  },
  {
    role: "Junior Data Analyst",
    org: "Cognizant Technology Ltd",
    dates: "16-APR-2012 – 25-FEB-2015",
  },
];

export const education = {
  education: [
    "Master in Pharmaceutics",
    "Executive PG in Data Analytics – Artificial Intelligence (IIT Roorkee)",
  ],
  certifications: [
    "Certified Clinical Data Manager (SCDM)",
    "Six Sigma Green Belt (Amile Institute)",
  ],
};

export const contact = {
  email: "raulfia.uchit@gmail.com",
  linkedin: "https://www.linkedin.com/in/rahuluchit1111",
  phone_de: "491726878701",
  phone_in: "918452018970",
};